import { InsuranceType, MainPath } from "Constants/constants";

export const PRODUCT_PATH = `/${MainPath.CHECK_PRICE}/${InsuranceType.AKA_HOUSE_CONTENTS}`;

export enum AkaHouseContentsSum {
  LOWER_LIMIT = 150000,
  UPPER_LIMIT = 3000000,
  UPPER_LIMIT_HOUSE_RENTED_OUT = 500000,
}

export const AKA_HOUSE_CONTENTS_DEDUCTIBLE = "3000";
